/**
 * Route for `regional-support-hours`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { RegionalSupportHoursPage } from "../features/regional-support-hours/RegionalSupportHoursPage";

export const regionalSupportHoursRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/regional-support-hours",
	component: RegionalSupportHoursPage,
});

export default regionalSupportHoursRoute;
